import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IDetailModalProps } from '@/modules/wealth/types';
import {
  BaseText,
  ButtonPrimary,
  ButtonSecondary,
  ButtonContainer,
  Heading
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'CostDetail',
  props: {
    modalInfo: null
  },
  setup(__props: any) {

const closeModal = inject('closeDetailModal') as () => void;
const router = useRouter();



return { __sfc: true,closeModal, router, NebraskaColors, BaseText, ButtonPrimary, ButtonSecondary, ButtonContainer, Heading }
}

})